<template>
  <a class="small-12 medium-3 large-3 columns aviso" 
    :href="file.doc_ficheiros_url">
      <img :src="pdficon" class="pdf_icon" /> 
      {{ file.doc_ficheiros_nome }} 
  </a>
</template>

<script>
import pdficon from "@/assets/images/pdf_icon.png";

export default {
  props: ["file"],
  setup(){
    return {
      pdficon
    }
  }
}
</script>

<style lang="scss" scoped>
a.aviso{
  padding-bottom: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: "Montserrat SemiBold";
  font-size: 14px;
  text-align: center;
  line-height: 24px;
  border: 1px solid #6eb7ec;
  text-decoration: none;
  color: #6eb7ec;
  margin-bottom: 10px;
  margin-right: 10px;
}

a:hover{
  border: 1px solid #488ec1;
  color: #488ec1;
}

.pdf_icon{
  height: 32px;
  width: 27px;
  display: block;
  margin-top: 10px;
  margin-bottom: 8px;
}

@media screen and (max-width:767px) {
  a.aviso{
    flex-direction: row;
    border: 0;
  }

  .pdf_icon {
    margin-right: 8.3px;
    margin-left: 3.266px;
    margin-top: 0
  }
}
</style>